module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Ultralight.5e22011.woff";